export default {
  common: {
    back: '返回',
    cancel: '取消',
    noBooking: '未找到预约信息',
    openFromBooking: '请从预约详情重新进入。',
    loadFailed: '加载失败',
    retry: '重试'
  },
  views: {
    change: {
      policy:
        '更改政策：仅可更改为同一乘车日、原车次发车前且有空位的车次；可多次更改。乘车区间和人数不能更改。',
      confirmSelect: '确认更改',
      submittedTitle: '预订已更改',
      submittedThanks: '感谢您的预订，请返回首页查看出票结果'
    },
    trainList: {
      vehicleInfo: '车辆信息',
      ticketName: '小田急浪漫特快',
      travelDate: '参加日期：',
      route: '出发和到达：',
      ticketCount: '预约数量：',
      trainType: '车型：',
      seatClass: '座位类型：',
      preference: '位置偏好：',
      preOrderNote: '',
      selectStation: '选择车站',
      from: '出发',
      to: '到达',
      swap: '交换出发站和到达站',
      selectTrain: '选择车次',
      select: '选择',
      book: '预订',
      seatAvailable: '余票充足',
      seatLimited: '余票不足',
      soldOut: '票已售罄',
      notOnSale: '暂未开售',
      noTimeRanges: '暂无可预约时间段',
      noTrains: '该时间段暂无车次'
    },
    seat: {
      title: '请选择座位',
      ticketCount: '预约数量：',
      selectMethod: '选择座位方式',
      selectByPreference: '根据条件指定',
      selectBySeatMap: '根据座位表指定',
      preference: '位置偏好',
      car: '车厢',
      noCarPreference: '未指定',
      selectSeats: '请选择座位（{{selected}}/{{total}}）',
      seatLabel: '座位 {{seat}}',
      seatMapDescription: '*A/D座位靠窗，B/C座位靠过道。无法跨车厢指定座位。',
      noSeats: '当前车厢没有可选座位',
      noTrain: '未选择车次',
      selectTrainFirst: '请返回并选择车次。',
      next: '下一步'
    },
    confirm: {
      trainConfirm: '车次确认',
      ticketName: '小田急浪漫特快',
      route: '出发和到达：',
      travelDate: '参加日期：',
      ticketCount: '预约数量：',
      trainType: '车型：',
      seatClass: '座位类型：',
      preference: '位置偏好：',
      confirmSelect: '确认选择',
      noTrain: '未选择车次',
      selectTrainFirst: '请返回并选择车次。'
    },
    submitted: {
      title: '预约已提交',
      thanks: '感谢您的预订，请返回首页查看出票结果',
      ticketName: '小田急浪漫特快',
      route: '出发和到达：',
      travelDate: '参加日期：',
      ticketCount: '预约数量：',
      trainType: '车型：',
      seatClass: '座位类型：',
      preference: '位置偏好：',
      backHome: '返回首页'
    },
    notFound: {
      title: '页面不存在',
      message: '请检查地址后重试。'
    }
  }
};
